import React from 'react'
import { Card, CardContent, SvgIcon, Typography } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { ReactComponent as ReleaseToMeIcon } from '../Release2Me/assets/release2me-icon.svg'
import { useWindowDimensions } from '../../services/hooks/useWindowDimensions'

export const Release2MeShortcut = (props) => {
  const history = useHistory()

  // This is to make the screen responsive on the MFPs. Media queries did not work
  const { width } = useWindowDimensions()

  let cardWidth = "200px"
  let cardHeight = "154px"
  let cardMargin = "8px"
  let textWidth = "168px"
  let picSide = "98px"
  if (width < 864) {
      cardWidth = "160px"
      cardHeight = "110px"
      cardMargin = "10px"
      textWidth = "128px"
      picSide = "60px"
  }
  if (width <= 800) {
      cardWidth = "142px"
  }

  const cardStyles = {
    width: cardWidth,
    maxHeight: cardHeight,
    margin: cardMargin,
    background: "#E6E6E6",
    boxShadow: "none",
    borderRadius: 0,
    justifyContent: "center",
    visibility: 'visible',
  }

const divStyle = {
    position: 'relative',
    width: picSide,
    height: picSide
}

const action = props.action ?? (() => history.push('/release2me/jobs'))

  return (
    <Card sx={cardStyles} onClick={ () => action() }>
      <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", position: "relative" }}>
        <div style={divStyle}>
          <SvgIcon 
            component={ReleaseToMeIcon}
            inheritViewBox
            sx={{
              maxWidth: '100%',
              maxHeight: picSide,
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              width: 'auto',
              fontSize: width < 864 ? 60 : 98
            }}
          />
        </div>
        <Typography sx={{
          fontSize: 14,
          "textAlign": "center",
          "textOverflow": "ellipsis",
          overflow: "hidden",
          "whiteSpace": "nowrap",
          "maxWidth": textWidth,
        }}>{'Release2Me'}</Typography>
      </CardContent>
    </Card>
  )
}